import { ErrorResponse } from '../models';

export const errorResponses = [
    {
        responseCode: 'prp-rs-042',
        errorMessage: 'The file could not be uploaded because it contains <strong>invalid paying accounts</strong>. Correct these accounts and try again.'
    },
    {
        responseCode: 'prp-rs-071',
        errorMessage: 'The file could not be uploaded because it contains <strong>duplicate ordering account numbers</strong>. Remove any duplicates and try again.'
    },
    {
        responseCode: 'prp-rs-072',
        errorMessage: 'The file could not be uploaded because it contains<strong> duplicate program IDs</strong>. Remove any duplicates and try again.'
    },
    {
        responseCode: 'prp-rs-073',
        errorMessage: 'The file could not be uploaded because it contains <strong>duplicate paying account numbers</strong>. Remove any duplicates and try again.'
    },
    {
        responseCode: 'prp-rs-074',
        errorMessage: 'The Paying Accounts file could not be uploaded because it contains invalid characters. Remove any special characters <strong>other than &#58; &#59; &apos; &#44;	&#46; &#95; &#45;</strong> and try again.'
    },
    {
        responseCode: 'prp-rs-075',
        errorMessage: 'The Ordering Accounts file could not be uploaded because it contains invalid characters. Remove any characters <strong>other than &#58; &#59; &apos; &#44;	&#46; &#95; &#45;</strong> and try again.'
    },
    {
        responseCode: 'prp-rs-076',
        errorMessage: 'The Program Service file could not be uploaded because it contains invalid characters. Remove any characters <strong>other than &#58; &#59; &apos; &#44;	&#46; &#95; &#45;</strong> and try again.'
    },
    {
        responseCode: 'prp-rs-043',
        errorMessage: 'Input data for Payer Account & Order Account are missing or no data.'
    }

] as ErrorResponse[];
